// Import external libraries
import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Router } from 'react-router-dom';

// Import styles
import './App.css';

// Import components
import CustomRouter, { customHistory } from './router';
import Header from './components/header/header';

function App() {
    return (
        <Router history={customHistory}>
            <Flex direction='column' height='100%'>
                <Header />
                <CustomRouter />
            </Flex>
        </Router>
    );
}

export default App;
